import React, {PureComponent, Fragment} from "react"
import PropTypes from "prop-types"

import Poll from "./Poll"
import Recognition from "./Recognition"

const RECOGNITION = "recognition"
const POLL = "poll"

export default class FeedCard extends PureComponent {
  static propTypes = {
    item: PropTypes.object.isRequired
  }

  render() {
    const {item} = this.props

    return (
      <Fragment>
        {item.type === POLL && <Poll {...this.props} item={item} />}
        {item.type === RECOGNITION && <Recognition {...this.props} item={item} />}
      </Fragment>
    )
  }
}
